import ResponsiveContainer from '../../../layouts/ResponsiveContainer'
import Titles from '../../../components/Titles/Titles'
import Button from '../../../components/Buttons/Button'
import { IMediaAndContent } from '../../../interfaces/MediaAndContent'
import MediaAndText from '../../../components/Cards/MediaAndText'
import PaginationDots from '../../../components/Pagination/PaginationDots'
import { Link } from 'react-router-dom'
import useCarousel from '../../../hooks/useCarousel'

const Researchs = ({ researchs }: { researchs: IMediaAndContent[] }) => {
    const totalSlides = researchs.length;
    const tripled = [...researchs, ...researchs, ...researchs];

    const { index, transition, goTo, handleTouchStart, handleTouchMove, handleTouchEnd } = useCarousel(totalSlides, 5000);

    return (
        <section className="flex flex-col justify-center w-full items-center bg-brand-brown-20 py-[3.25rem] md:py-13">
            <ResponsiveContainer className='flex flex-col lg:flex-row justify-between gap-12 overflow-hidden'>
                <div className='flex flex-col gap-4 w-full lg:w-1/2'>
                    <Titles title='Informes' withBgPattern={false} color='text-primary-100' />
                    <span className='text-primary-100 text-blarge'>
                        Informes e investigaciones desarrollados a partir de los datos disponibles en nuestros indicadores.
                    </span>
                    <Link to='/monitor/informes'>
                        <Button
                            label='Ver todos'
                            showIconLeft={false}
                            showIconRight={false}
                            variant='primary'
                        />
                    </Link>
                </div>

                <div
                    className='w-full xl:w-1/2 flex flex-col overflow-hidden'
                    onTouchStart={handleTouchStart}
                    onTouchMove={handleTouchMove}
                    onTouchEnd={handleTouchEnd}
                >
                    <div
                        className="flex mb-7"
                        style={{
                            transform: `translateX(-${index * 100}%)`,
                            transition: transition ? 'transform 500ms ease-in-out' : 'none',
                        }}
                    >
                        {tripled.map((research, i) => (
                            <Link
                                to='/monitor/informes'
                                className='min-w-full sm:flex sm:justify-center lg:justify-end hover:brightness-110 hover:opacity-100 transition-all duration-300'
                                key={`${research.id}-${i}`}
                            >
                                <MediaAndText
                                    imagen={research.imagen}
                                    titulo={research.titulo}
                                    texto={research.descripcion}
                                    fecha={research.fecha}
                                    bg='bg-brand-brown-10'
                                />
                            </Link>
                        ))}
                    </div>

                    <PaginationDots
                        total={totalSlides}
                        currentIndex={index % totalSlides}
                        hidden={false}
                        shape='square'
                        activeColor="bg-primary-100"
                        inactiveClass="border border-primary-100"
                        onDotClick={(i) => goTo(totalSlides + i)}
                    />
                </div>
            </ResponsiveContainer>
        </section>
    );
};

export default Researchs